import React from "react";
import TopBar from "./TopBar";
import NetworkGate from "./NetworkGate";
import NoInternet from "./NoInternet";
import AppRoutes from "../navigation/AppRoutes";

import bg from "../assets/gradient.jpg";
import { ToastProvider } from "./ToastProvider";

const TOPBAR_H = 80;

export default function AppShell() {
  return (
    <ToastProvider>
      {/* Global autofill styles */}
      <style>
        {`
          input:-webkit-autofill,
          input:-webkit-autofill:hover,
          input:-webkit-autofill:focus,
          input:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
            -webkit-text-fill-color: #000 !important;
            caret-color: #000 !important;
            transition: background-color 5000s ease-in-out 0s;
          }

          input::placeholder {
            color: #000;
            opacity: 0.6;
          }
        `}
      </style>

      <div
        style={{
          ...styles.shell,
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div style={styles.topBarSlot}>
          <TopBar />
        </div>
        <div style={styles.content}>
          <NetworkGate offline={<NoInternet />} online={<AppRoutes />} />
        </div>
      </div>
    </ToastProvider>
  );
}

const styles: Record<string, React.CSSProperties> = {
  shell: {
    height: "100vh",
    overflow: "hidden",
  },
  topBarSlot: {
    height: TOPBAR_H,
  },
  content: {
    height: `calc(100vh - ${TOPBAR_H}px)`,
    overflowY: "auto",
    overflowX: "hidden",
  },
};
